import React, { Component } from 'react'
import T from './translate/T'

import Modal from './atoms/Modal'
import Modalv2 from './atoms-v2/Modal'
import { Container, Row, Hidden, Col } from './atoms/Grid'
import Link from './atoms/Link'
import Icon from './atoms/FontIcon'
import Button from './atoms/Button'
import Valign from './atoms/Valign'
import Logo from './atoms/Logo'
import Avatar from './atoms/Avatar'
import If from './atoms/If'
import FloatBox from './atoms/FloatBox'
import Font from './atoms/Font'
import Loading from './atoms/Loading'

import Search from './Search'
import MyInscriptions from './MyInscriptions'

import UserNotifications from './UserNotifications'
import style from './style.css'
import { Config } from './_config.js'

import AsyncComponent from './atoms/AsyncComponent'
import * as Cookies from './libraries/Cookies'
import { getDomainWithoutSubdomain } from './libraries/Domain'


import * as utils from './utils.js'

const LoginModal = AsyncComponent(() => import('./login'), (<Loading style={{padding:'60px'}} />))
const SignupModal = AsyncComponent(() => import('./signup'), (<Loading style={{padding:'60px'}} />))


class Topbar extends Component {

  constructor(props) {
    super(props)

    T.setLanguages({
      'default': 'pt-br',
      'en-us': () => import('./translate/languages/en-us.json'),
      'pt-br': () => import('./translate/languages/pt-br.json'),
    })

    this.state = {
      menuActive: false,
      logged: false,
      logonStatus: 'loading',
      modal_search: false,
      modal_inscriptions: false,
      userData: null,
      authorization: null,
      notificationsUnread: 0
    }

    this.openModal = this.openModal.bind(this)
    this.closeModal = this.closeModal.bind(this)
    this.toggleFloatBox = this.toggleFloatBox.bind(this)

    T.handleUpdate(() => {
      this.forceUpdate()
    })
  }

  componentWillMount() {
    this.props.handleLogin({
      status: this.state.logonStatus,
      logged: this.state.logged,
      authorization: null
    })

    if(!utils.getAuthorization()) {

      this.setState({
        ...this.state,
        userData: {},
        logonStatus: 'done',
        logged: false,
      })

      this.props.handleLogin({
        status: 'done',
        logged: false,
        data: {},
        authorization: null
      })

      return
    }

    utils.logon()
    .then( data => {
      if(!data.errors) {
        this.setState({
          ...this.state,
          userData: { ...data },
          logonStatus: 'done',
          logged: true,
        })
      } else {
        this.setState({
          ...this.state,
          logged: false,
          userData: null,
          logonStatus: 'done'
        })
      }

      this.props.handleLogin({
        status: this.state.logonStatus,
        logged: this.state.logged,
        data,
        authorization: utils.getAuthorization()
      })
    })


    this.componentWillReceiveProps( this.props )
  }

  logout() {
    utils.logout()
    .then(() => {
       this.setState({
         ...this.state,
         logged: false,
         data: {},
         authorization: null
       })
       this.props.handleLogin({
         status: this.state.logonStatus,
         logged: false,
         data: {},
         authorization: null
       })
    })


  }

  handleCreatedUser( response ) {
    this.loggedIn(response)
  }

  componentWillReceiveProps(nextProps) {
    if(nextProps.modalOpened) {
      this.openModal(nextProps.modalOpened)
    }

    if(this.state.logonStatus === 'done' && nextProps.isLogged !== this.props.isLogged && this.state.logged && !nextProps.isLogged)
      this.logout()

    if(nextProps.language)
      T.setLanguage(nextProps.language)
  }

  loggedIn( data ) {
    this.closeModal('modal-login')
    this.closeModal('modal-signup')

    utils.setAuthorization(data.authorization)
    // localStorage.setItem('authorization', data.authorization)
    // sessionStorage.setItem('authorization', data.authorization)
    Cookies.setCookie('authorization', data.authorization, 30 * 24 * 3600 * 12, getDomainWithoutSubdomain()) //1 ano

    this.setState({
      ...this.state,
      userData: data.user,
      logonStatus: 'done',
      logged: true
    }, () => {
      this.props.handleLogin({
        status: this.state.logonStatus,
        logged: this.state.logged,
        data: this.state.userData,
        authorization: data.authorization
      })
    })


  }

  closeModal(ref) {
    if(this.refs[ref])
    this.refs[ref].hide()
  }

  openModal(ref) {
    if(this.refs[ref])
    this.refs[ref].show()

    this.props.handleModalClose( ref )
  }

  toggleFloatBox(evt, ref) {
    this.refs['floatBoxUser'].hide()
    this.refs['floatBoxNotification'].hide()
    this.refs[ref].toggle(evt)
  }

  toggleMenuSM() {
    var status = false
    if(!this.state.menuActive) {
      status = true
    }

    this.setState({
      menuActive: status
    })
  }

  LoginModalAsync = () => (
    <LoginModal handleLogin={ data => this.loggedIn(data) } handleBtnSignup={() => {
      this.closeModal('modal-login')
      this.openModal('modal-signup')
      }} />
  )

  SignupModalAsync = () => (
    <SignupModal handleCreated={ res => this.handleCreatedUser(res) } handleBtnLogin={() => {
      this.closeModal('modal-signup')
      this.openModal('modal-login')
      }} />
  )

  handleInscriptions = () => {
    this.setState({
      modal_inscriptions: true
    })
    this.refs['floatBoxUser'].hide()
  }

  render() {
    const notLogged = () => (
        <div className={style.topbarRight}>
          <div style={{float:"left", marginRight: '10px'}}>
            <Hidden sm>
              <div className={style.link} style={{width: '130px'}}>
                <Valign>
                  <Button style={{fontSize: '12px'}} color='link-orange' onClick={() => this.openModal('modal-signup')}>{T.text('register')}</Button>
                </Valign>
              </div>
            </Hidden>
          </div>

          <div className={style.link}>
            <Valign>
              <Button style={{
                width: '100px',
                height: '32px',
                textTransform: 'uppercase',
                padding: '0 20px',
                fontSize: '12px'
              }} color='grey-orange' onClick={() => this.openModal('modal-login')}>{T.text('login')}</Button>
            </Valign>
          </div>
          {/* <Hidden sm> */}
          <div className={style.icon}>
            <Valign text='center'>
              <Link href={Config.linkSearch}>
                <Icon size={18} name='search' />
              </Link>
            </Valign>
          </div>

          <div className={style.icon}>
            <Valign text='center'>
              <a href={Config.linkExplore}>
                <Icon color='#f50' size={26} name='compass' />
              </a>
            </Valign>
          </div>
        </div>
    )

    const userLogged = () => (
      <div className={style.topbarRight} style={{position: 'relative'}}>
        <div style={{float: 'left'}}>
            <div className={style.icon}>
              <Valign text='center'>
                <Link href={Config.linkSearch}>
                  <Icon size={20} name='search' />
                </Link>
              </Valign>
            </div>

            <div className={style.icon}>
              <Valign text='center'>
                <a href={Config.linkExplore}>
                  <Icon size={26} color='#f50' name='compass' />
                </a>
              </Valign>
            </div>
        </div>

        <div className={style.icon}>
          <Valign text='center'>
            <Link onClick={(e) => {
                this.toggleFloatBox(e, 'floatBoxNotification')
              }}>
              <div className={style.notification}>
                <If test={this.state.notificationsUnread}>
                  <div className={style.notificationBullet}>
                      { this.state.notificationsUnread }
                  </div>
                </If>
                <Icon size={26} name='user-notification' />
              </div>
            </Link>
          </Valign>
        </div>
        <div className={`${style.icon} ${style.iconAvatar}`}>
          <Valign text='center'>
            <Link onClick={(e) => {
              this.toggleFloatBox(e, 'floatBoxUser')
            }}>
              <Avatar img={this.state.userData && this.state.userData.avatar !== '' ? `${Config.assetsBase}${this.state.userData.avatar}` :  ''} size='40' />
            </Link>
          </Valign>
        </div>

        <If test={this.state.logged}>
          <FloatBox
            ref='floatBoxNotification'
            arrowRight='65px'>
            <UserNotifications handleUnreadNotifications={ unread => this.setState({
              notificationsUnread: unread
            }) } />
          </FloatBox>

          <FloatBox ref='floatBoxUser' arrowRight='11px'>
            <div className={style.floatBoxUser}>
                <div className={style.user}>
                  <Avatar style={{float:'left'}} size='72' img={this.state.userData && this.state.userData.avatar !== '' ? `${Config.assetsBase}${this.state.userData.avatar}` :  ''} />
                  <div className={style.userName}>
                      <div className={style.text}>
                        <Font size='18' color='#545454' style={{fontWeight:'bold'}}>
                          {this.state.userData && this.state.userData.name}
                        </Font>
                      </div>
                      <a href={`${Config.myAccount}${this.state.userData && this.state.userData.url_token}`}>
                        <Button min color='grey'>{T.text('my_account')}</Button>
                      </a>
                  </div>
                </div>
                <ul className={style.links}>
                  <li>
                    <Link href={`${Config.myEvents}`}>{T.text('my_events')}</Link>
                  </li>
                  <li>
                    <Link href={`${Config.linkBase}user/${this.state.userData && this.state.userData.url_token}/subscriptions/`}>{T.text('my_inscriptions')}</Link>
                  </li>
                  <li>
                  <Link href='https://partners.sprinta.com.br/profissionais' target='_blank'>Seja um profissional parceiro</Link>
                  </li>
                  <li>
                    <Link onClick={() => this.logout()}>{T.text('exit')}</Link>
                  </li>
                </ul>

            </div>
            <div className={style.footerEvent}>
              <a href={`${Config.createEvent}`}>
                <Button color='orange'>{T.text('create_event')}</Button>
              </a>
            </div>
            
          </FloatBox>
        </If>

      </div>
    )

    return (
      <header>
        <div className={style.topbar}>
          <Container>
            <Row>
              <Col>
                <div className={style.logo}>
                  <Valign>
                    <a href={Config.linkHome}>
                      <Logo size='100px' />
                    </a>
                  </Valign>
                </div>

                <If test={this.state.logonStatus === 'done'}>
                    <If test={!this.state.logged}>
                      {notLogged()}
                    </If>
                    <If test={this.state.logged}>
                      {userLogged()}
                    </If>
                </If>
              </Col>
            </Row>
          </Container>
        </div>

        <div className={style.spacer} />

        <If test={!this.state.logged}>
          <Modal
            ref='modal-login'
            padding='0'
            width='800px'
            component={this.LoginModalAsync}
            />

          <Modal
            ref='modal-signup'
            padding='0'
            width='680px'
            component={this.SignupModalAsync}
          />
        </If>

        <If test={this.state.logged}>
          <Modalv2
            style={{ width: "700px" }}

            active={ this.state.modal_inscriptions }
            handleClose={ () => {
              this.setState({
                modal_inscriptions: false
              })
            }}
            loadContent={ this.state.modal_inscriptions }
            >
              <MyInscriptions />
            </Modalv2>
        </If>
        <Modalv2
          style={{ width: "1080px" }}
          active={ this.state.modal_search }
          handleClose={ () => {
            this.setState({
              modal_search: false
            })
          }}>
          <Search logged={this.state.logged} handleRouterLink={() => {
            this.setState({
              modal_search: false
            })
          }} />
        </Modalv2>
      </header>
    )
  }
}

export default Topbar



// WEBPACK FOOTER //
// ./src/SPRINTA/Topbar/index.js